import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import pl from 'vuetify/es5/locale/pl'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#0D47A1'
        // secondary: '#b0bec5',
        // accent: '#8c9eff',
        // error: '#b71c1c',
      }
    }
  },
  lang: {
    locales: { pl },
    current: 'pl'
  }
})
